import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import { ApiClient } from './api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logged_in: false,
    mobile: false,
    messageStatus: false,
    messageText: '',
    messageType: '',
    messagePhone: '',
    messagePassword: '',
    messageClick: () => {},
    authorization: '',
    xAccessToken: '',
    userId: '',
    messageTimeout: '',
    username: '',
    phone: '',
    email: '',
    nickname: '',
    region: '',
    loading: true,
    clientAuthTimeout: '',
    messageTime: 3000,
    refreshTime: 300000,
    deleteCookieTime: -1,
    areaCodeJson: [],
    oldHashedPassword: '',
    oldPasswordSeed: '',
    oldUsername: '',
    signUpVerificationNumber: '',
    signUpMobile: '',
    signUpAreaCode: '',
    indexShowId: -1
  },
  getters: {
    versionPrefix: () => {
      return process.env.VUE_APP_VERSION.slice(0, 1).toUpperCase()
    }
  },
  mutations: {

  },
  actions: {
    /**
     * 获取随机数
     */
    generateSeed () {
      const seedArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      const seed = seedArr[Math.floor(Math.random() * 62)] + seedArr[Math.floor(Math.random() * 62)] + seedArr[Math.floor(Math.random() * 62)] + seedArr[Math.floor(Math.random() * 62)]
      return seed
    },
    /**
     * 获取用户代理
     *
     * @param {*} { state }
     */
    getUserAgent ({ state }) {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        state.mobile = true
      } else if (/(Android)/i.test(navigator.userAgent)) {
        state.mobile = true
      } else {
        state.mobile = false
      }
    },
    /**
     *  获取cookie
     *
     * @param {*} { state }
     * @param {string} key 健值
     * @returns
     */
    getCookie ({ state }, key) {
      return new Promise((resolve, reject) => {
        const cookie = decodeURI(document.cookie)
        const cookieArr = cookie.split(';')
        let success = false
        cookieArr.forEach((element) => {
          if (key === element.split('=')[0].replace(/ /g, '') && element.split('=')[1].replace(/ /g, '') !== '') {
            resolve(element.split('=')[1].replace(/ /g, ''))
            success = true
          }
        })
        if (!success) {
          reject(key)
        }
      })
    },
    /**
     * 设置cookie
     *
     * @param {*} { state }
     * @param {object} cookie 设置对象
     */
    setCookie ({ state }, cookie) {
      let cookieExpires = ''
      let cookiePath = ';path=/'
      if (cookie.expires) {
        const day = new Date()
        day.setTime(day.getTime() + (cookie.expires * 1000))
        cookieExpires = ';expires=' + day.toGMTString()
      }
      if (cookie.path) {
        cookiePath = ';path=' + cookie.path
      }
      document.cookie = cookie.key + '=' + cookie.value + cookieExpires + cookiePath
    },
    /**
     * 顶部弹窗
     *
     * @param {*} { state }
     * @param {object} message 弹窗对象
     */
    popMessage ({ state }, message) {
      clearTimeout(state.messageTimeout)
      state.messageStatus = true
      state.messageText = message.text
      state.messageType = message.type
      if (message.password) {
        state.messagePassword = message.password
      }
      if (message.phone) {
        state.messagePhone = message.phone
      }
      if (message.click) {
        state.messageClick = message.click
      } else {
        state.messageTimeout = setTimeout(() => {
          state.messageStatus = false
        }, state.messageTime)
      }
    },
    submitClientAuth ({ state, dispatch }) {
      return new Promise((resolve) => {
        const client = new ApiClient()
        client.submitClientAuth(process.env.VUE_APP_CLIENT_ID, process.env.VUE_APP_SECRET_KEY_HASH, process.env.VUE_APP_SEED).then((res) => {
          state.authorization = res.data.authorization
          clearTimeout(state.clientAuthTimeout)
          if (!state.logged_in) {
            state.clientAuthTimeout = setTimeout(() => {
              dispatch('submitClientAuth')
            }, state.refreshTime)
          }
          resolve()
        })
      })
    },
    signOut ({ state, dispatch }) {
      state.logged_in = false
      state.userId = ''
      state.xAccessToken = ''
      state.indexShowId = -1
      dispatch('setCookie', {
        key: 'access_token',
        value: '',
        expires: state.deleteCookieTime
      })
      dispatch('setCookie', {
        key: 'user_id',
        value: '',
        expires: state.deleteCookieTime
      })
      dispatch('submitClientAuth')
      router.push({ name: 'sign-in' }).catch(() => {})
    },
    loading ({ state, dispatch }) {
      return new Promise((resolve) => {
        dispatch('getCookie', 'access_token').then((res) => {
          state.xAccessToken = res
          dispatch('getCookie', 'user_id').then((res) => {
            state.userId = res
            state.logged_in = true
            dispatch('submitClientAuth').then(() => {
              resolve()
            })
          }).catch(() => {
            state.logged_in = false
            if (router.history.current.name !== 'index' && router.history.current.name !== 'contact-us' && router.history.current.name !== 'disclaimer') {
              router.replace({
                name: 'sign-in'
              })
            } else {
              if (router.history.current.name === 'index') {
                router.replace({
                  name: 'sign-in'
                })
              }
            }
          })
        }).catch(() => {
          state.logged_in = false
          if (router.history.current.name !== 'index' && router.history.current.name !== 'contact-us' && router.history.current.name !== 'disclaimer') {
            router.replace({
              name: 'sign-in'
            })
          } else {
            if (router.history.current.name === 'index') {
              router.replace({
                name: 'sign-in'
              })
            }
          }
        })
      })
    }
  }
})
